import React, { Component } from "react";
import Select from "react-select";
import { ListButton } from "react-admin";
import { Papa } from "../common/common";

import {
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
  DigitalOrderSystem,
  EmptyPagination,
} from "../common/common";
import Swal from "sweetalert2";

class SoAppNotificationCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      successMsg: false,
      validationError: false,
      validationTitleError: false,
      validationPurposeError: false,
      validateDescriptionError: false,
      saveButtonDisabled: true,
      errorMsg: false,
      errorMsgText: null,
      type: "Country",
      saleOffNameSapCode: [],
      parsedCSVdata: [],
      descCharLeft: 500,
      descMaxChar: 500,
      unregisteredRetailers: [],
      pasrsedSimilarDataLength: 0,
      pasrsedDifferentDataLength: 0,
      unregisteredRetailersToggle: false,
      saleOffList: [],
    };
  }
  componentWillMount() {
    const { props, state } = this;
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";
    fetch(`${apiUrl}/so_list`, options)
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        console.log("jsonD ===>", jsonD);
        let obj = {};
        obj.sap_order_materials = jsonD.data;
        obj.loadingShow = false;
        // console.log('obj==>', obj);
        this.setState({
          originalList: obj.sap_order_materials.map((item) => ({
            id: item.id,
            value: item.label,
            label: item.label + " " + item.email,
            email: item.email.trim(),
          })),
          saleOffNameSapCode: obj.sap_order_materials.map((item) => ({
            id: item.id,
            value: item.label,
            label: item.label + " " + item.email,
            email: item.email.trim(),
          })),
        });
      });
  }
  handleChange = (e) => {
    console.log("hiiii", e);
    console.log(
      "saleOffNameSapCode in handleChange",
      this.state.saleOffNameSapCode
    );
    const arr = [...this.state.originalList];

    let result =
      arr &&
      arr.filter((item) => e && e.filter((i) => i.id === item.id).length === 0);
    if (e === null) {
      result = [...this.state.originalList];
      this.setState({ saleOffList: [] });
    }
    // console.log('result', result)
    this.setState({
      saleOffList: e,
      saleOffNameSapCode: result,
    });
  };

  titleChange = (e) => {
    console.log("e >>>>>>>>>", e.target.value);
    if (
      e.target.value === "" ||
      e.target.value === undefined ||
      e.target.value === null ||
      !e.target.value.trim().length
    ) {
      this.setState({
        validationError: true,
        validationTitleError: true,
      });
    } else {
      this.setState({
        validationError: false,
        validationTitleError: false,
      });
    }
    this.setState({ SoAppTitle: e.target.value });
  };

  purposeChange = (e) => {
    console.log("e >>>>>>>>>", e.target.value);
    if (
      e.target.value === "" ||
      e.target.value === undefined ||
      e.target.value === null ||
      !e.target.value.trim().length
    ) {
      this.setState({
        validationError: true,
        validationPurposeError: true,
      });
    } else {
      this.setState({
        validationError: false,
        validationPurposeError: false,
      });
    }
    this.setState({ SoAppPurpose: e.target.value });
  };

  selectHandleChange = (event) => {
    this.setState({ type: event.target.value });
  };

  descriptionChange = (e) => {
    console.log("e >>>>>>>>>", e.target.value);
    const charCount = e.target.value.length;
    const maxChar = this.state.descMaxChar;
    const charLength = maxChar - charCount;

    if (
      e.target.value === "" ||
      e.target.value === undefined ||
      e.target.value === null ||
      !e.target.value.trim().length
    ) {
      this.setState({
        validationError: true,
        validateDescriptionError: true,
        descCharLeft: charLength,
      });
    } else {
      this.setState({
        validationError: false,
        validateDescriptionError: false,
        descCharLeft: charLength,
      });
    }

    this.setState({ SoAppDescription: e.target.value });
  };

  formSave = () => {
    this.setState({
      showLoader: true,
      saveButtonDisabled: false,
    });
    const formData = {
      title: this.state.SoAppTitle.trim(),
      description: this.state.SoAppDescription.trim(),
      type: this.state.type,
      name_email: this.state.saleOffList,
      purpose: this.state.SoAppPurpose.trim(),
    };
    console.log("formData>>>>>>", formData);

    const apiUrl = RUN_TIME_API_ENDPOINT;
    const options = CommonHeaderOption();
    options.method = "POST";
    options.body = JSON.stringify({ formData });

    return fetch(`${apiUrl}/so_in_app_notifications`, options)
      .then((res) => {
        console.log("res12...........", res);
        if (res) {
          return res.json();
        }
      })
      .then((res) => {
        if (res.errorMsg) {
          this.setState({
            errorMsg: true,
            showLoader: false,
            errorMsgText: res.errorMsg,
          });
          setTimeout(() => {
            this.setState({
              errorMsg: false,
              saveButtonDisabled: true,
            });
          }, 3000);
        } else {
          console.log("res...........", res);
          this.setState({
            showLoader: false,
            saveButtonDisabled: true,
            successMsg: true,
          });
          setTimeout(() => {
            this.setState({ successMsg: false });
          }, 2000);
          setTimeout(() => {
            this.props.history.push("/so_in_app_notifications");
          }, 3000);
          console.log("res", res);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleFile = (e) => {
    let file = null;
    file = e.target.files[0];
    const fileType = file.name.substring(
      file.name.lastIndexOf(".") + 1,
      file.name.length
    );
    if (
      file === null ||
      typeof file === "undefined" ||
      file === "" ||
      typeof file === undefined ||
      fileType.toLowerCase() !== "csv"
    ) {
      Swal.fire({
        text: "Please choose a valid .csv file.",
        confirmButtonText: `OK`,
        icon: "error",
      });
      file = null;
      console.log("bad file");
    } else {
      console.log([e.target.name], e.target.files[0]);
      this.setState({
        unregisteredRetailers: [],
        pasrsedSimilarDataLength: 0,
        pasrsedDifferentDataLength: 0,
      });
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          const checkValidHeader = Object.keys(results.data[0]);
          // console.log('results======>', Object.keys(results.data[0]).includes('COMPANYNAME'));
          if (
            checkValidHeader.includes("COMPANYNAME") &&
            checkValidHeader.includes("EMAIL")
          ) {
            const parseddata = results.data.map((item, i) => ({
              id: i,
              value: item.COMPANYNAME + " " + item.EMAIL,
              label: item.COMPANYNAME + " " + item.EMAIL,
              email: item.EMAIL.trim(),
            }));
            console.log(parseddata);
            let pasrsedSimilarData = [];
            pasrsedSimilarData = this.state.originalList.filter((a1) =>
              parseddata.some((a2) => a1.email === a2.email)
            );
            if (pasrsedSimilarData && pasrsedSimilarData.length) {
              const similarArray =
                this.state.saleOffList !== null
                  ? this.state.saleOffList.filter(
                      ({ email: id1 }) =>
                        !pasrsedSimilarData.some(
                          ({ email: id2 }) => id2 === id1
                        )
                    )
                  : [];
              this.setState({
                saleOffList: [...similarArray, ...pasrsedSimilarData],
                pasrsedSimilarDataLength: pasrsedSimilarData.length,
              });
            }
            const pasrsedDifferentData = parseddata.filter((a1) =>
              pasrsedSimilarData.every((a2) => a1.email !== a2.email)
            );
            if (pasrsedDifferentData && pasrsedDifferentData.length) {
              console.log(pasrsedDifferentData, pasrsedDifferentData.length);
              this.setState({
                unregisteredRetailers: [...pasrsedDifferentData],
                pasrsedDifferentDataLength: pasrsedDifferentData.length,
              });
            }
            console.log("seprated", pasrsedSimilarData, pasrsedDifferentData);
            this.setState({ parsedCSVdata: [...parseddata] });
          } else {
            file = null;
            Swal.fire({
              text: "File headers do not match. Kindly download and refer the sample file.",
              confirmButtonText: `OK`,
              icon: "error",
            });
          }
        },
      });
    }
  };

  cancelClick = () => {
    this.setState({
      saleOffList: [],
      saleOffNameSapCode: this.state.originalList,
      unregisteredRetailers: [],
      pasrsedSimilarDataLength: 0,
      pasrsedDifferentDataLength: 0,
    });
  };

  toggleUnregisteredRetailers = () => {
    this.setState({
      unregisteredRetailersToggle: !this.state.unregisteredRetailersToggle,
    });
  };

  render() {
    console.log("state ==>", this.state, this.props);
    return (
      <div>
        <div className="notification-list-button">
          <ListButton basePath={this.props.basePath} />
        </div>
        <div className="so-form-container">
          <div className="so-form">
            <div className="so-input">
              <label>
                Notification Purpose<sup>*</sup>
              </label>
              <input
                className="form-control"
                type="text"
                name="Purpose"
                value={this.state.SoAppPurpose || ""}
                onChange={this.purposeChange}
              />
              {this.state.validationPurposeError && (
                <p className="so-input-error">Please enter a Purpose</p>
              )}
            </div>

            <div className="so-input">
              <label>
                Notification Title<sup>*</sup>
              </label>
              <input
                className="form-control"
                type="text"
                name="Title"
                value={this.state.SoAppTitle || ""}
                onChange={this.titleChange}
              />
              {this.state.validationTitleError && (
                <p className="so-input-error">Please enter a title</p>
              )}
            </div>

            <div className="so-input">
              <label>
                Notification Description<sup>*</sup>
              </label>
              <textarea
                className="inapp-notification-description"
                name="description"
                maxLength="500"
                value={this.state.SoAppDescription}
                onChange={this.descriptionChange}
              />
              {this.state.validateDescriptionError && (
                <p className="so-input-error">Please enter a description</p>
              )}
              <p className="characters-remaining">
                {this.state.descCharLeft} characters remaining
              </p>
            </div>

            {/* <input type="file" id="file" onChange={this.handleFile} /> */}

            <div className="so-input">
              <label>
                Notification Send To<sup>*</sup>
              </label>
              <select
                className="inapp-notification-sendto"
                name="type"
                value={this.state.type}
                onChange={this.selectHandleChange}
              >
                <option value="Country">All Sales Officer</option>
                <option value="SalesOfficer">A set of Sales Officer</option>
              </select>
            </div>

            {this.state.type === "SalesOfficer" && (
              <div className="target-upload-container">
                <div className="csv-file-upload-container">
                  <label>Upload File</label>
                  {/* <input type="file" accept=".csv" name="flies[]" /> */}
                  <input
                    type="file"
                    id="file"
                    accept=".csv"
                    onChange={this.handleFile}
                  />
                  <div className="valid-file-upload">
                    <p>Instructions :</p>
                    <ul>
                      <li>
                        Only CSV files are allowed with Comma as separator.
                      </li>
                    </ul>
                  </div>
                  <div className="upload-file-format-download">
                    <p>
                      To get upload file format.{" "}
                      <a
                        href="https://clickit-static-files-prod.s3.eu-west-1.amazonaws.com/fille_formats/so_in_app_notification.csv"
                        target="_blank"
                      >
                        Click here
                      </a>{" "}
                      to download
                    </p>
                  </div>
                </div>

                {this.state.pasrsedSimilarDataLength > 0 ||
                this.state.pasrsedDifferentDataLength > 0 ? (
                  <div className="csv-result-container">
                    <label>CSV Result</label>
                    <div className="csv-result">
                      <p onClick={this.toggleUnregisteredRetailers}>
                        {this.state.pasrsedSimilarDataLength} sales officers
                        found, {this.state.pasrsedDifferentDataLength} sales
                        officers unregistered.
                        {this.state.pasrsedDifferentDataLength > 0
                          ? " Click to view unregistererd sales officer"
                          : ""}
                        {this.state.pasrsedDifferentDataLength > 0 ? (
                          <span
                            className={
                              this.state.unregisteredRetailersToggle
                                ? `icon-arrow_down`
                                : `icon-arrow_up`
                            }
                          />
                        ) : (
                          ""
                        )}
                      </p>
                      {this.state.pasrsedDifferentDataLength > 0 ? (
                        <div
                          className={
                            this.state.unregisteredRetailersToggle
                              ? `hide-unregistered`
                              : `show-unregistered`
                          }
                        >
                          <React.Fragment>
                            {this.state.unregisteredRetailers.map((item) => (
                              <p key={item.id}>{item.label}</p>
                            ))}
                          </React.Fragment>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <label className="select-label">
                  Choose Sales Officer<sup>*</sup> (Atleast select one Sales
                  Officer)
                </label>
                <div className="select-retailer">
                  <Select
                    value={this.state.saleOffList}
                    onChange={this.handleChange}
                    options={this.state.saleOffNameSapCode}
                    isMulti
                  />
                  <button onClick={this.cancelClick}>Clear</button>
                </div>
              </div>
            )}
          </div>
          {this.state.saveButtonDisabled && (
            <div className="so-save-button">
              <button
                className={
                  !this.state.SoAppTitle ||
                  !this.state.SoAppDescription ||
                  !this.state.SoAppPurpose ||
                  this.state.validationTitleError ||
                  this.state.validateDescriptionError ||
                  this.state.validationPurposeError ||
                  (this.state.type === "SalesOfficer" &&
                    !this.state.saleOffList)
                    ? "disable-save"
                    : ""
                }
                disabled={
                  this.state.validationTitleError ||
                  this.state.validateDescriptionError ||
                  this.state.validationPurposeError ||
                  !this.state.SoAppTitle ||
                  !this.state.SoAppDescription ||
                  !this.state.SoAppPurpose ||
                  (this.state.type === "SalesOfficer" &&
                    !this.state.saleOffList)
                }
                onClick={() => this.formSave()}
              >
                Save
              </button>
            </div>
          )}

          {this.state.showLoader && <div className="save-loader" />}
          {this.state.successMsg && (
            <div className="so-updated">Successfully Created </div>
          )}
          {this.state.errorMsg && (
            <div className="so-email-exist">{this.state.errorMsgText}</div>
          )}
        </div>
      </div>
    );
  }
}

export default SoAppNotificationCreate;
